<div class="main-container">
  <ng-content select="[icon]"></ng-content>
  <h1 class="header">{{ headerTitle() }}</h1>
  <ng-content select="[instructions]"></ng-content>
  <ng-content select="[content]"></ng-content>
  <ng-content select="[footer]"></ng-content>
</div>
